import { ACCOUNT_ROUTE_NAME } from "@/libs/route-name";
import type { RouteRecordRaw } from "vue-router";

export const affiliateReferralRoute = (): RouteRecordRaw => ({
  path: "/affiliate/referral",
  name: ACCOUNT_ROUTE_NAME.AFFILIATE,
  component: () => import("@/pages/affiliate/index.vue")
});
